<template>
    <Card>
        <div class="yl-flex flex_between">
            <Form :label-width="80">
                <FormItem label="时间">
                    <RadioGroup v-model="timePeriod" @on-change="changeDate">
                        <Radio label="0" border><span>不限</span></Radio>
                        <Radio label="1" border><span>今日</span></Radio>
                        <Radio label="2" border><span>昨天</span></Radio>
                        <Radio label="3" border><span>本周</span></Radio>
                        <Radio label="4" border><span>上周</span></Radio>
                        <Radio label="5" border><span>本月</span></Radio>
                        <Radio label="6" border><span>上月</span></Radio>
                        <Radio label="7" border><span>自定义</span></Radio>
                        <DatePicker v-if="timePeriod == '7' " :value="timePeriodDate" @on-change="changeTimePeriod"
                                    type="daterange" placeholder="选择日期" class="date-picker"></DatePicker>
                    </RadioGroup>
                </FormItem>
                <FormItem label="条件">
                    <el-select v-model="city" class="select-option" placeholder="请选择城市">
                        <el-option v-for="item in cityList" :value="item.city" :key="item.city">
                            {{ item.city}}
                        </el-option>
                    </el-select>
					<el-select v-model="advertiserId" multiple class="select-option" placeholder="请选择账户id">
					    <el-option v-for="item in advertiserIdList" :value="item.advertiserId" :key="item.advertiserId">
					        {{ item.advertiserId}}
					    </el-option>
					</el-select>
                    <el-Input placeholder="计划id" v-model="searchAdid" class="input-field"></el-Input>
					<el-Button type="primary" @click="mySearch" class="button">搜索</el-Button>
					<el-Button @click="initSearch" class="button">重置</el-Button>
                </FormItem>
            </Form>
        </div>
        <div class="table-container">
            <Table :columns="defaultColumns" :data="datas" ref="table" @on-sort-change="handleSortChange">
                <template slot-scope="{ row,index }" slot="adid">
                    <span class="adid-link" @click.stop="adidDataClick(row.adid)">{{row.adid}}</span>
                </template>
                <template slot-scope="{ row,index }" slot="twoplusSlot">
                    <div v-if="row.our_num !=0">
                        <span>{{row.twoplus+row.three+row.four}}/{{(((row.twoplus+row.three+row.four)/row.our_num).toFixed(2))}}</span>
                    </div>
                    <div v-if="row.our_num ==0">
                        <span>{{row.twoplus+row.three+row.four}}/0</span>
                    </div>
                </template>
                <template slot-scope="{ row,index }" slot="zhuangku_rate">
                    <div v-if="row.zhuangku_rate >0.2">
                        <span class="high-rate">{{row.zhuangku_rate}}</span>
                    </div>
                    <div v-else>
                        <span>{{row.zhuangku_rate}}</span>
                    </div>
                </template>
                <template slot-scope="{ row,index }" slot="threePlus">
                    <div v-if="row.our_num !=0">
                        <span>{{row.three+row.four}}/{{(((row.three+row.four)/row.our_num).toFixed(2))}}</span>
                    </div>
                    <div v-if="row.our_num ==0">
                        <span>{{row.three+row.four}}/0</span>
                    </div>
                </template>
                <template slot-scope="{ row,index }" slot="min3">
                    <div v-if="row.our_num !=0">
                        <span>{{row.min3}}/{{(((row.min3)/row.all_num).toFixed(2))}}</span>
                    </div>
                    <div v-if="row.our_num ==0">
                        <span>{{row.three+row.four}}/0</span>
                    </div>
                </template>
                <template slot-scope="{ row,index }" slot="threePlusReal">
                    <div v-if="row.all_num !=0">
                        <span>{{row.three+row.four}}/{{(((row.three+row.four)/row.all_num).toFixed(2))}}</span>
                    </div>
                    <div v-if="row.all_num ==0">
                        <span>{{row.three+row.four}}/0</span>
                    </div>
                </template>
                <template slot-scope="{ row,index }" slot="remark">
                    <div v-for="(item,index) in row.alarm_msg"
                         :class="{'status-tag one': item.name == 'one','status-tag twoplus':item.name == 'twoplus','status-tag threeplus':item.name == 'threeplus','status-tag cost':item.name == 'cost'}">
                        <span>{{item.msg}}</span>
                    </div>
                </template>
            </Table>
        </div>
        <div class="pagination-container">
            <Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
                  :current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small"
                  show-elevator/>
        </div>
        <Modal v-model="adidDataModal" width="1200" title="">
            <adidData :adid="adid" :timePeriod="timePeriod" :timePeriodDate="timePeriodDate" :city="city" :src="src"
                      :account="account" :cid_type="cid_type" :adv_id="2" :advertiserId="advertiserId" :operationUser="operationUser"></adidData>
        </Modal>
        <Modal v-model="clientListModal" width="1200" title="">
            <clientList :cityList="cityList" :cidTypeList="cidTypeList" :srcList="srcList" :accountList="accountList"
                        :operationList="operationList" :account="account" :operationUser="operationUser"></clientList>
        </Modal>
        <Modal v-model="lookAdidCostModal" width="1200" title="">
            <AdvEmptyCost :cityList="cityList"></AdvEmptyCost>
        </Modal>
    </Card>
</template>
<script>
import {
    mapGetters
} from "vuex";
import {
    getAdvCity,
} from "../../api/runSet";
import {
    getDefaultCityDemandList,
    saveSingleDefaultDemand,
    getCidTypeList,
    saveAllDemand,
    getCkhAdvDataList,
    getAllAccountList,
    getAllOperationList,
    getToutiaoSrc
} from "../../api/advManage.js";
import adidData from "./components/adidData.vue"
import AdvEmptyCost from "./AdvEmptyCost.vue"
import clientList from "./components/clientList.vue"
import cityData from "../../assets/citydata";

export default {
    name: "toutiao_adv_data",
    components: {
        adidData,
        clientList,
        AdvEmptyCost
    },

    data() {
        return {
            datas: [],
            timePeriod: '1',
            timePeriodDate: [],
            page: 1,
            pageSize: 20,
            editStatus: 0,
            pageSizeOpts: [10, 50, 100, 500],
            count: 0,
            city: '',
            src: '',
            advCity: '',
            cid_type: '',
            cityList: [],
			advertiserIdList:[],
            cidTypeList: [],
            srcList: [],
            accountList: [],
            operationList: [],
            operationUser: [],
            account: [],
            adidDataModal: false,
            clientListModal: false,
            lookAdidCostModal: false,
            adid: '',
            searchAdid: '',
			advertiserId:'',
            adName: '',
            sort: { // 排序参数
                field: '', // 排序的字段
                order: '' // 排序的顺序（'ascending' 或 'descending'）
            },
            defaultColumns: [{
                "title": "计划id",
                "slot": "adid",
                "align": 'center',
				width:'100'
            },
			{
			    "title": "账户id",
			    "key": "advertiserId",
			    "align": 'center',
				width:'100'
			},
                {
                    "title": "媒体代码",
                    "key": "src",
                    "align": 'center',

                },
                {
                    "title": "所有城市量",
                    "key": "all_num",
                    "align": 'center',
                    sortable: 'custom'
                },
                {
                    "title": "已回传数量",
                    "key": "our_num",
                    "align": 'center',
                    sortable: 'custom'
                },
                {
                    "title": "已分发数量",
                    "key": "distribute_num",
                    "align": 'center',
                    sortable: 'custom'
                },
                {
                    "title": "未分发数量",
                    "key": "not_distribute_num",
                    "align": 'center',
                    sortable: 'custom'
                },
                {
                    "title": "撞库数量",
                    "key": "zhuangku_num",
                    "align": 'center',
                    sortable: 'custom'
                },
                {
                    "title": "撞库率",
                    "slot": "zhuangku_rate",
                    "align": 'center',
                    sortable: 'custom'
                },
                {
                    "title": "0星",
                    "key": "zero",
                    "align": 'center',
                    sortable: 'custom'
                },
                {
                    "title": "1星",
                    "key": "one",
                    "align": 'center',
                    sortable: 'custom'
                },
                {
                    "title": "2星+以上",
                    "slot": "twoplusSlot",
                    "align": 'center',
                    sortable: 'custom'
                },
                {
                    "title": "3星+以上",
                    "slot": "threePlus",
                    "align": 'center',
                    sortable: 'custom'
                },
                {
                    "title": "实际3星+以上",
                    "slot": "threePlusReal",
                    "align": 'center',
                    sortable: 'custom'
                },
                {
                    "title": "3万以下",
                    "slot": "min3",
                    "align": 'center',
                    sortable: 'custom'
                },
                {
                    "title": "完件率",
                    "key": "finish_rate",
                    "align": 'center',
                    sortable: 'custom'
                },
            ],
        }
    },
    computed: {
        ...mapGetters(['token', 'userInfo'])
    },
    mounted: function () {
        this.loadData();
    },
    methods: {

        async loadData() {
            let that = this;
            let data = {}
            data.token = this.token;
            let res = await getAdvCity(that, data);
            that.cityList = res.data.list;
					
            res = await getCidTypeList(that, data);
            that.cidTypeList = res.data.list;
            res = await getToutiaoSrc(that, data);
            that.srcList = res.data.list;
			that.advertiserIdList = res.data.advertiserIdList;
            res = await getAllAccountList(that, data);
            that.accountList = res.data.list;
            res = await getAllOperationList(that, data);
            that.operationList = res.data.list;
            console.log(that.userInfo.role_type)
            if (that.userInfo.role_type == 15) {
                that.operationList = [];
                that.accountList = [];
                that.srcList = [];
            }
            this.getList();
        },
        mySearch(e) {
            this.page = 1;
            this.getList();
        },
        initSearch() {
            this.page = 1;
            this.pageSize = 20;
            this.city = '';
            this.src = '';
            this.adName = '';
            this.cid_type = '';
            this.searchAdid = '';
			this.advertiserId = '';
            this.timePeriod = '1';
            this.timePeriodDate = [];
            this.operationUser = [];
            this.account = [];
            this.getList();
        },
        async getList() {
            let that = this;
            var data = this.$data;
            data.token = that.token;
            let res = await getCkhAdvDataList(that, data);
            that.datas = res.data.list;
            console.log(res)
            that.count = res.count;

        },
        lookClientlist() {
            let that = this;
            that.clientListModal = true;
        },
        lookAdidCost() {
            let that = this;
            that.lookAdidCostModal = true;
        },
        adidDataClick(adid) {
            let that = this;
            if (adid == "合计") {
                that.adid = "";
            } else {
                that.adid = adid;
            }
            that.adidDataModal = true;
        },
        handleSortChange({
                             column,
                             prop,
                             order
                         }) {
            this.sort.field = column.key ? column.key : column.slot;
            this.sort.order = order;
            this.page = 1;
            this.getList();
        },
        changeDate(e) {
            //this.getList();
        },
        changeTimePeriod(e) {
            this.timePeriodDate = e;
            console.log(this.timePeriodDate)
            this.getList();
        },
        changePage(e) {
            this.page = e;
            this.getList();
        },
        changeSize(e) {
            this.pageSize = e;
            this.getList();
        },
    },
}
</script>
<style scoped lang="less">
.red {
    color: red;
}

.multiple {
    display: flex;
    justify-content: left;
    margin-top: 10px;
    align-items: center;

   .child-div {
        width: 70px;
        height: 20px;
        margin-right: 30px;
        text-align-last: justify;
    }
}

.hong {
    color: #F56171;
    font-weight: bold;
}

.lan {
    color: #124386;
    font-weight: bold;
}

.sousuo {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.yl-flex {
    display: flex;
}

.flex_between {
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.ivu-table-header thead tr th {
    text-align: center !important;
}

.ivu-table-cell {
    padding-left: 2px;
    padding-right: 2px;
    text-align: center;
}

.ivu-table table {
    width: 100% !important;
}

.green-bg {
    background: #18bc9c;
}

.blue-bg {
    background: #54A1F3;
}

.person {
    font-size: 14px;
    color: white;
    border-radius: 50%;
    width: 22px;
    height: 20px;
}

.in-block {
    display: inline-block;
}

.one {
    background-color: #E74C3C;
    cursor: pointer;
    color: #fff;
}

.twoplus {
    background-color: #F1C40F;
    cursor: pointer;
    color: #fff;
}

.threeplus {
    background-color: #2ECC71;
    cursor: pointer;
    color: #fff;
}

.cost {
    background-color: #E67E22;
    cursor: pointer;
    color: #fff;
}

.is_stop_city {
    background-color: #9c4e00;
    cursor: pointer;
    color: #fff;
}

.date-picker {
    width: 200px;
}

.select-option {
    width: 150px;
    margin-left: 10px;
}

.input-field {
    width: 150px;
    margin-left: 10px;
}

.button {
    margin-left: 10px;
}

.table-container {
    width: 100%;
    margin-top: 20px;
}

.pagination-container {
    margin-top: 20px;
}

.adid-link {
    color: #63B3E6;
    cursor: pointer;
}

.high-rate {
    color: #ffaa00;
    cursor: pointer;
}

.status-tag {
    padding: 2px 4px;
    margin: 2px;
    border-radius: 4px;
}
</style>    